var _ = require('underscore');
var TorsoView = require('backbone-torso/modules/View');
var EregStaffPatientAppointmentDetailsView = require('./EregStaffPatientAppointmentDetailsView');
var EregAppointmentSelectWorkflowFormView = require('../select-workflow-nodes/EregAppointmentSelectWorkflowFormView');
var UseModalBehavior = require('./../../widget/modal/UseModalBehavior');
var ModalDialogWidget = require('./../../widget/modal/ModalDialogWidget');
var EregAppointmentSelectWorkflowFormModel = require('../select-workflow-nodes/EregAppointmentSelectWorkflowFormModel');
var EregStaffSelectWorkflowReviewView = require('./../staff-select-workflow-review-modal/EregStaffSelectWorkflowReviewView');
var eregStaffSelectWorkflowTemplate = require('./eregStaffSelectWorkflowTemplate.hbs');
var staffLogoutWithRedirectToEreg = require('./../../authentication/logoutUtils').staffLogoutWithRedirectToEreg;
var AppointmentNavigationConfirmBehavior = require('../navigation-confirm/AppointmentNavigationConfirmBehavior');
var eregWorkflowConfigService = require('./../../wizard/eregWorkflowConfigService');
var AppointmentDataBehavior = require('./../../appointment/AppointmentDataBehavior');
var wizardUtils = require('./../../wizard/wizardUtils');
var WizardAccessBehavior = require('./../../wizard/WizardAccessBehavior');

/**
 * Perspective to display the E-reg staff select workflow page.
 *
 * @class EregStaffSelectWorkflowPerspective
 * @constructor
 * @param options {Object} the options for creating this view.
 *   @param options.patientVecnaId {String} Vecna id of the patient that the appointment is for.
 *   @param options.appointmentExternalId {String} id of the appointment to view.
 * @uses appointmentNavigationConfirmMixin
 */
module.exports = TorsoView.extend({
  className: 'brec-main',
  tagName: 'main',
  template: eregStaffSelectWorkflowTemplate,
  moduleNamespace: 'eregStaffSelectWorkflow',

  behaviors: {
    useModalBehavior: UseModalBehavior,
    wizardAccessBehavior: WizardAccessBehavior,
    appointmentNavigationConfirm: AppointmentNavigationConfirmBehavior,
    appointment: {
      behavior: AppointmentDataBehavior,
      renderOnFetch: true,
      id: { property: '_appointmentExternalIds' }
    }
  },

  events: {
    'click [data-save]': '_openReviewModal'
  },

  injectionSites: {
    'appointment-details': '_eregStaffPatientAppointmentDetailsView',
    'select-workflow': '_eregAppointmentSelectWorkflowFormView'
  },

  /**
   * @method initialize
   * @param options {Object} the options for creating this view.
   *   @param options.patientVecnaId {String} Vecna id of the patient that the appointment is for.
   *   @param options.appointmentExternalId {String} id of the appointment to view.
   *   @param options.regDate {String} the date of the appointments to view.
   * @override
   */
  initialize: function(options) {
    var thisView = this;

    this._patientVecnaId = options.patientVecnaId;
    this._appointmentExternalId = options.appointmentExternalId;
    this._regDate = options.regDate;

    this._appointmentExternalIds =
      wizardUtils.getSelectedPreRegWizardAppointmentExternalIds(this._appointmentExternalId, this._regDate);

    this._eregStaffPatientAppointmentDetailsView = new EregStaffPatientAppointmentDetailsView({
      patientVecnaId : this._patientVecnaId,
      appointmentExternalIds: this._appointmentExternalIds
    });

    this._selectWorkflowModel = new EregAppointmentSelectWorkflowFormModel();
    this._eregAppointmentSelectWorkflowFormView = new EregAppointmentSelectWorkflowFormView({
      model: this._selectWorkflowModel
    });

    this.set({
      asideHeaderMessageKey: 'ereg.appointments.aside.header',
      asideContentMessageKey: 'ereg.staffSelectWorkflow.aside'
    });

    this.set('navView', 'eregStaff');

    var appointmentBehavior = this.getBehavior('appointment');
    this.listenTo(appointmentBehavior, 'fetched', function() {
      var appointmentTypes = appointmentBehavior.data.get('externalAppointment.type');
      thisView._eregAppointmentSelectWorkflowFormView.set('appointmentTypeExternalIds', appointmentTypes);
    });
  },

  /**
   * Sets the review modal to render and provides it with the data it needs.
   * @method _openReviewModal
   * @private
   */
  _openReviewModal: function() {
    var appointmentBehavior = this.getBehavior('appointment');
    var appointmentModels = appointmentBehavior.data.getModels();
    this.showModal(new ModalDialogWidget({
      dataViewName: 'review appointment',
      className: 'brec-dialog brec-dialog--regular',
      headerKey: 'eregStaffSelectWorkflow.reviewModal.header',
      closeTitleKey: 'eregStaffSelectWorkflow.reviewModal.close',
      yesClass: 'brec-btn--full-width',
      yesKey: 'eregStaffSelectWorkflow.reviewModal.allSetBtn',
      noClass: 'brec-btn--full-width',
      noKey: 'eregStaffSelectWorkflow.reviewModal.editBtn',
      footerClass: 'brec-dialog__menu--extra-side-padding',
      stackButtons: true,
      trackedView: new EregStaffSelectWorkflowReviewView({
        patientVecnaId : this._patientVecnaId,
        appointmentModels: appointmentModels,
        workflowFormModel: this._selectWorkflowModel
      })
    }), _.bind(this._saveEregWorkflowConfig, this));
  },

  /**
   * Saves the ereg workflow config to the session storage
   * @method _saveEregWorkflowConfig
   * @private
   */
  _saveEregWorkflowConfig: function() {
    var workflowFormModel = this._eregAppointmentSelectWorkflowFormView.model;
    var eregWorkflowConfig  = {
      patientVecnaId: this._patientVecnaId,
      appointmentExtId: this._appointmentExternalId,
      regDate: this._regDate,
      disabledSteps: workflowFormModel.getDisabledWorkflowSteps()
    };

    eregWorkflowConfigService.setEregWorkflowConfig(eregWorkflowConfig);
    staffLogoutWithRedirectToEreg();
  }
});
